module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"group":"Group","columns":{"name":"Name"}},"de":{"group":"Gruppe","columns":{"name":"Name"}}}')
  delete Component.options._Ctor
}
